<template>
  <div id="wallet" class="wallet_information">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.wallet')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow >
      <template #right>
        <div @click="showDetails">{{ $t('column.details') }}</div>
      </template>
    </van-nav-bar>
    <van-row class="wallet">
      <!-- 总余额卡片 -->
      <van-col span="22" offset="1" class="balance-card">
        <van-col span="22" offset="1">
          <van-col span="24" class="total-label">{{ $t('column.total_names',{name: ticket_name})}}</van-col>
          <van-col span="24" class="total-amount">
            <img src="../assets/img/coin9.png"/> {{ totalBeans }}
          </van-col>
        </van-col>
        <van-col span="24" class="balance-card-bg">
          <van-col span="22" offset="1">
            <van-col span="12">
              <van-col span="24" class="balance-label">{{ $t('column.withdrawal_names',{name: ticket_name})}}</van-col>
              <van-col span="24" class="balance-value">
                <img src="../assets/img/coin9.png" />{{ withdrawalBeans }}
              </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="20" class="balance-label">{{ $t('column.names_to_be_confirmed',{name: ticket_name})}}</van-col>
              <van-col span="4" class="arrow-icon">
                <van-icon name="arrow" size="12" />
              </van-col>
              <van-col span="24" class="balance-value">
                <img src="../assets/img/coin9.png" />{{ pendingBeans }}
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>


      <!-- 提现规则卡片 -->
      <van-col span="22" offset="1" class="withdrawal-rules-card" v-if="is_withdrawal">
        <van-col span="24" class="rules-title">{{ $t('wallet.withdrawal_rate') }}</van-col>
        <van-col span="24" class="rules-content">
          <van-row class="rule-item" v-if="one_dollar_ticket">
            <van-col span="12" class="rule-label">{{ $t('wallet.exchange_ratio') }}</van-col>
            <van-col span="12" class="rule-value">
              <img src="../assets/img/coin9.png" class="coin-icon" /> {{ one_dollar_ticket }}=$1
            </van-col>
          </van-row>
          <van-row class="rule-item" v-if="ticket_catty_min">
            <van-col span="12" class="rule-label">{{ $t('wallet.min_withdrawal_amount') }}</van-col>
            <van-col span="12" class="rule-value">
              <img src="../assets/img/coin9.png" class="coin-icon" /> {{ ticket_catty_min }}
            </van-col>
          </van-row>
        </van-col>
      </van-col>
      <!-- 操作按钮组 -->
      <van-col span="22" offset="1" class="action-buttons">
        <van-button 
          type="primary" 
          class="btn-primary" 
          block
          round
          v-if="is_withdrawal"
          @click="handleCashOut"
        >
          {{ $t('wallet.cashout_now') }}
        </van-button>
        <van-button 
          class="btn-secondary" 
          block
          round
          @click="handleExchange"
          v-if="is_exchange"
        >
          {{ $t('wallet.exchange_beans_for_diamonds') }}
        </van-button>
        <van-button 
          class="btn-secondary" 
          block
          round
          @click="handleTransfer"
          v-if="is_transfer"
        >
          {{ $t('wallet.transfer') }}
        </van-button>
        
      </van-col>
    </van-row>

  </div>
</template>

<script>

import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  name: 'Wallet',
  data() {
    return {
      ticket_name: '',
      totalBeans: 0,
      withdrawalBeans: 0,
      pendingBeans: 0,
      is_coin_seller: 0,
      is_transfer: 0,
      is_exchange: 0,
      is_withdrawal: 0,
      one_dollar_ticket: 0,
      ticket_catty_min: 0
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    // 千位分隔符格式化方法
    formatNumber(num) {
      if (!num && num !== 0) return '';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    get_list() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_wallet_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.totalBeans = this.formatNumber(res.data.data.total)
          this.withdrawalBeans = this.formatNumber(res.data.data.withdrawal_total)
          this.pendingBeans = this.formatNumber(res.data.data.pending_total)
          this.ticket_name = res.data.data.ticket_name
          this.is_coin_seller = res.data.data.is_coin_seller
          this.is_transfer = res.data.data.is_transfer
          this.is_exchange = res.data.data.is_exchange
          this.one_dollar_ticket = res.data.data.one_dollar_ticket ? this.formatNumber(res.data.data.one_dollar_ticket) : 0
          this.ticket_catty_min = res.data.data.ticket_catty_min ? this.formatNumber(res.data.data.ticket_catty_min) : 0
          this.is_withdrawal = res.data.data.is_withdrawal
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/wallet_details', query: { uid: uid, token: token } })
    },
    handleCashOut() {
      // 提现功能
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/wallet_withdraw', query: { uid: uid, token: token } })
    },
    handleExchange() {
      // 豆子兑换钻石功能 判断是否是币商，如果是则跳转到币商兑换页面，否则跳转到普通兑换页面；
       const uid = this.$route.query.uid
      const token = this.$route.query.token
      if (this.is_coin_seller) {
        this.$router.push({ path: '/coin_dealer_exchange', query: { uid: uid, token: token } })
      } else {
        this.$router.push({ path: '/exchange_coin', query: { uid: uid, token: token } })
      }
    },
    handleTransfer() {
      // 转账功能
    //   const uid = this.$route.query.uid
    //   const token = this.$route.query.token
    //   this.$router.push({ path: '/wallet_transfer', query: { uid: uid, token: token } })
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/wallet_information.vue